/*
Ashraf 12/23/2022 2700524332 fixed double toast issue
*/

import {createSlice} from '@reduxjs/toolkit';
import {httpPost} from '../../util/Rest';

const initialData = {
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  mailStatus: '',
  resetPasswordStatus: '',
};

const slice = createSlice({
  name: 'forgotPassword',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    postmail: (state, action) => {
      state.isLoading = false;
      // state.errorMsg = action?.payload?.response;
      state.successMsg = action?.payload?.response;
      state.mailStatus = action?.payload?.status;
    },
    resetPassword: (state, action) => {
      state.isLoading = false;
      // state.errorMsg = action?.payload?.response;
      state.successMsg = action?.payload?.response;
      state.mailStatus = action?.payload?.status;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.message ? action.payload.data.message : '';
      state.isLoading = false;
    },
    resetSuccess: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.mailStatus = null;
    },
    resetEmailMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.mailStatus = null;
    },
  },
});

export default slice.reducer;

// Actions

const {fetchStart, resetSuccess, fetchError, postmail, resetEmailMsg, resetPassword} = slice.actions;

export const postforgotPassword = (emailId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`forget/password/${emailId}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          // dispatch(fetchError(data));
          dispatch(postmail(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postResetPassword = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`reset/user/password`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          // dispatch(fetchError(data));
          dispatch(resetPassword(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetMsg = () => {
  return (dispatch) => {
    dispatch(resetSuccess());
  };
};

export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetEmailMsg());
  };
};
